<template>
  <div class="flyer-container">
    <header class="flyer-header">
      <h1>הפכו את היישוב שלכם למסלול ספורט בטוח!</h1>
    </header>
    <section class="flyer-content">
      <h2>מה זה?</h2>
      <p>
        המשחק שלנו מאפשר לכם לרוץ או ללכת באוויר הפתוח תוך שמירה על קרבה
        למקלטים. זו פעילות ספורטיבית וכיפית, מושלמת לחיזוק הבריאות והקהילה, גם
        בתקופות של מתח.
      </p>
      <h2>איך זה עובד?</h2>
      <ul>
        <li>אנחנו יוצרים מסלול מותאם אישית ליישוב או לקיבוץ שלכם.</li>
        <li>המשתתפים רצים ממקלט למקלט, בהתאם להוראות שבאפליקציה.</li>
        <li>
          במקרה של אזעקה, תמיד תהיו קרובים למקלט כדי להיכנס ולהגן על עצמכם.
        </li>
      </ul>
      <h2>מה אנחנו צריכים מכם?</h2>
      <p>
        <strong>קואורדינטות GPS</strong> של המקלטים ביישוב שלכם, וכמה פרטים
        פשוטים בטופס ההזמנה.
      </p>
    </section>
    <footer class="flyer-footer">
      <h2>הזמינו את המשחק ליישוב שלכם עוד היום!</h2>
      <p>צרו קשר בטלפון: <strong>052-1234567</strong></p>
      <p>
        מלאו את הטופס כאן: <a href="#" class="flyer-link">לחצו כאן להזמנה</a>
      </p>
      <p>או במייל: <strong>game@secure-navigation.com</strong></p>
      <div class="flyer-slogan">"זוזו, שמרו על ביטחון, תהנו!"</div>
    </footer>
  </div>
</template>
  
  <script>
export default {
  name: "FlyerHebrew",
};
</script>
  
  <style scoped>
.flyer-container {
  font-family: Arial, sans-serif;
  direction: rtl;
  text-align: right;
  margin: 20px auto;
  padding: 20px;
  max-width: 600px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #f9f9f9;
}
.flyer-header {
  background-color: #4caf50;
  color: white;
  padding: 10px;
  border-radius: 10px 10px 0 0;
  text-align: center;
}
.flyer-header h1 {
  margin: 0;
  font-size: 24px;
}
.flyer-content h2 {
  color: #4caf50;
  margin-top: 15px;
  font-size: 20px;
}
.flyer-content p,
.flyer-content ul {
  font-size: 16px;
  line-height: 1.6;
}
.flyer-content ul {
  margin: 10px 0;
  padding-left: 20px;
}
.flyer-footer {
  text-align: center;
  margin-top: 20px;
}
.flyer-footer h2 {
  color: #4caf50;
  font-size: 20px;
}
.flyer-footer p {
  font-size: 16px;
}
.flyer-link {
  color: #4caf50;
  text-decoration: none;
  font-weight: bold;
}
.flyer-link:hover {
  text-decoration: underline;
}
.flyer-slogan {
  margin-top: 20px;
  font-size: 18px;
  color: #333;
  font-weight: bold;
}
</style>